import React, { createContext, useMemo, useState } from 'react';

export const TourGuideContext = createContext({
	isTourEnabled: false,
	setIsTourEnabled: () => {},
	toggleTourEnabled: () => {},
});

const TourGuideProvider = ({ children }) => {
	const [isTourEnabled, setIsTourEnabled] = useState(false);

	const toggleTourEnabled = () => {
		setIsTourEnabled((prev) => !prev);
	};

	const values = useMemo(
		() => ({
			isTourEnabled,
			setIsTourEnabled,
			toggleTourEnabled,
		}),
		[isTourEnabled],
	);

	return <TourGuideContext.Provider value={values}>{children}</TourGuideContext.Provider>;
};

export default TourGuideProvider;
